import omit from 'lodash/omit';
import type { Version } from '../../common/model';
import type { Version as RestVersion } from '../../common/rest/types';
import {
	atlasKitToServerDateFormat,
	ISOToAtlasKitDateFormat,
	todayToAtlasKitDateFormat,
} from '../../common/utils/dates';
import type { ReleasableVersion } from '../model';

export const transformReleasableToRestVersion = (version: ReleasableVersion): RestVersion => {
	const restVersion = omit(version, ['issuesStatus']);

	return {
		...restVersion,
		released: true,
		// @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
		releaseDate: atlasKitToServerDateFormat(version.releaseDate),
	};
};

export const addDefaultReleaseDate = (version: Version): ReleasableVersion => {
	const { id, name, releaseDate, issuesStatus } = version;

	return {
		id,
		name,
		issuesStatus,
		moveUnfixedIssuesTo: '',
		releaseDate: releaseDate ? ISOToAtlasKitDateFormat(releaseDate) : todayToAtlasKitDateFormat(),
	};
};
